import {Pipe, PipeTransform} from '@angular/core';

type Primitive = boolean | number | string | null;

@Pipe({
  name: 'acmCutFieldName',
  pure: true
})

/**
 * Get nested object property value for primeNG table cell
 * @param rowInfo - any object (table row information)
 * @param columnConfig - should be object with ColumnConfig interface
 * @returns Primitive type such as boolean | string | number | null
 */
export class AcmCutFieldNamePipe implements PipeTransform {
  transform<T extends object>(rowInfo: T, columnConfigField: string): string {

    // check if row info parameter not an object
    if (rowInfo && (typeof rowInfo !== 'object' || Array.isArray(rowInfo))) {
      console.error('[AcmCutFieldNamePipe] - rowInfo not a Object', rowInfo);
      return null;
    }

    // get value for rowInfo
    const result: {} | Primitive = columnConfigField.split('.')
      .reduce((acc: {} | Primitive, objKey: string): {} | Primitive => {
        return acc && acc.hasOwnProperty(objKey) ? acc[objKey] : acc;
      }, rowInfo);

    // check if result is not a Primitive type
    if (typeof result !== 'string' && typeof result !== 'number' && typeof result !== 'boolean' && result !== null) {
      console.error('[AcmCutFieldNamePipe] - not a Primitive type', result);
      return null;
    }

    return result as string;
  }
}
